// app/javascript/controllers/dae20/autocomplete_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = {
    url: String,
    minLength: { type: Number, default: 1 }
  }

  connect() {
    this._activeIndex = -1
    this._debounceTimer = null
    this._onScroll = () => this.close()
    window.addEventListener("scroll", this._onScroll, true)
  }

  disconnect() {
    clearTimeout(this._debounceTimer)
    window.removeEventListener("scroll", this._onScroll, true)
  }

  onInput() {
    clearTimeout(this._debounceTimer)
    this._debounceTimer = setTimeout(() => this.search(), 300)
  }

  onKeydown(e) {
    if (!this.hasResultsTarget || this.resultsTarget.classList.contains("hidden")) {
      if (e.key === "ArrowDown") {
        this.search()
        e.preventDefault()
      }
      return
    }

    const items = this.resultsTarget.querySelectorAll("[data-label]")

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault()
        this._move(items, 1)
        break
      case "ArrowUp":
        e.preventDefault()
        this._move(items, -1)
        break
      case "Enter":
        e.preventDefault()
        this._selectActive(items)
        break
      case "Escape":
        this.close()
        break
    }
  }

  onBlur() {
    setTimeout(() => this.close(), 200)
  }

  search() {
    const q = this.inputTarget.value.trim()
    if (q.length < this.minLengthValue) {
      this.close()
      return
    }

    const sep = this.urlValue.includes("?") ? "&" : "?"
    const url = `${this.urlValue}${sep}q=${encodeURIComponent(q)}`

    fetch(url, { headers: { "Accept": "application/json" } })
      .then((r) => r.json())
      .then((data) => this.render(data.items || []))
      .catch(() => this.close())
  }

  render(items) {
    if (!items.length) {
      this.close()
      return
    }

    this._activeIndex = -1

    this.resultsTarget.innerHTML = items
      .map((item, i) => {
        const label = this.esc(String(item.label))
        return `
          <div data-index="${i}" data-label="${label}"
               class="px-3 py-1.5 text-sm text-gray-800 hover:bg-blue-50 cursor-pointer">
            ${label}
          </div>
        `
      })
      .join("")

    this._positionDropdown()
    this.resultsTarget.classList.remove("hidden")

    this.resultsTarget.querySelectorAll("[data-label]").forEach((el) => {
      el.addEventListener("mousedown", (e) => {
        e.preventDefault()
        this.inputTarget.value = el.dataset.label
        this.close()
      })
    })
  }

  _positionDropdown() {
    const rect = this.inputTarget.getBoundingClientRect()
    const dd = this.resultsTarget
    dd.style.left = `${rect.left}px`
    dd.style.top = `${rect.bottom + 2}px`
    dd.style.width = `${rect.width}px`
  }

  _move(items, direction) {
    if (!items.length) return

    if (this._activeIndex >= 0 && this._activeIndex < items.length) {
      items[this._activeIndex].classList.remove("bg-blue-100")
    }

    this._activeIndex = (this._activeIndex + direction + items.length) % items.length
    items[this._activeIndex].classList.add("bg-blue-100")
    items[this._activeIndex].scrollIntoView({ block: "nearest" })
  }

  _selectActive(items) {
    const el = items[this._activeIndex]
    if (el) {
      this.inputTarget.value = el.dataset.label
    }
    this.close()
  }

  close() {
    if (this.hasResultsTarget) {
      this.resultsTarget.innerHTML = ""
      this.resultsTarget.classList.add("hidden")
    }
    this._activeIndex = -1
  }

  esc(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
